import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { SpeedCoachingProfile } from '../schemas/speed-coaching-profile.schema';

/**
 * Edits a Speed Coaching Profile
 * @param speedCoachingProfile The Speed Coaching Profile being edited
 * @returns Data object indicating success
 */
export function putSpeedCoaching(
  this: unknown,
  speedCoachingProfile: Partial<SpeedCoachingProfile>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).speedCoachingUrl}/${
          speedCoachingProfile.speedCoachingProfileId ?? -1
        }`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(speedCoachingProfile),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
